var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmonstrPayment2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6c.276 0 .5.224.5.5v11c0 .276-.224.5-.5.5h-19c-.276 0-.5-.224-.5-.5v-11c0-.276.224-.5.5-.5h19zm2.5 0c0-1.104-.896-2-2-2h-20c-1.105 0-2 .896-2 2v12c0 1.104.895 2 2 2h20c1.104 0 2-.896 2-2v-12zm-4 3.938h-2.502l-.585.63-.546-.63h-5.383l-.463 1.064-.474-1.064h-4.241l-1.806 4.124h2.162l.267-.658h.613l.267.658h8.984l.602-.641.563.641h2.542l-1.811-2.051 1.811-2.073zm-12.11.467v.018l-.009-.018h.009zm4.665 3.077h-.697l-.006-2.318-1.02 2.318h-.624l-1.025-2.318v2.318h-1.438l-.273-.663h-1.471l-.273.663h-.769l1.265-2.959h1.053l1.198 2.798v-2.798h1.154l.925 2.006.853-2.006h1.148v2.959zm6.119 0h-.908l-.869-.981-.903.981h-2.798v-2.959h2.842l.869.97.897-.97h.869l-1.321 1.488 1.322 1.471zm-3.004-2.346l.774.864-.808.869h-1.739v-.591h1.549v-.602h-1.549v-.541h1.773zm-8.934-.111l.485 1.181h-.97l.485-1.181z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrPayment2);
export default __webpack_public_path__ + "static/media/iconmonstr-payment-2.861cdb95bb41e8fd705a2460a856048c.svg";
export { ForwardRef as ReactComponent };